export const SIGNER_STATUS = {
  AWAITING_SIGNATURE: 'AWAITING_SIGNATURE',
  PENDING: 'PENDING',
  ON_HOLD: 'ON_HOLD',
  SIGNED: 'SIGNED',
};

export const SIGNER_STATUS_LIST = Object.keys(SIGNER_STATUS);
